import { render } from "./OutcomesReports.vue?vue&type=template&id=537dab02&scoped=true"
import script from "./OutcomesReports.vue?vue&type=script&lang=js"
export * from "./OutcomesReports.vue?vue&type=script&lang=js"

import "./OutcomesReports.vue?vue&type=style&index=0&id=537dab02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537dab02"]])

export default __exports__